import { useSelector } from 'react-redux';
import { byVendor, vendorCafeteriaId } from '../utils/common';

// ----------------------------------------------------------------------

// The vendor the user picked after login, resolved through the roster.
export default function useVendor() {
  const {
    EmployeeReducers: { vendorName },
    RosterReducers: { rosterList },
    UserHomeReducers: { vendorId },
  } = useSelector((state) => state);

  const found = (vendorName || []).find((v) => +v.id === +vendorId);
  const vendor = found ? { id: +found.id, name: found.name } : null;

  return {
    vendorId,
    vendor,
    // Cafeteria a booking for this vendor on that day goes against (null when not rostered)
    cafeteriaFor: (date) => vendorCafeteriaId(rosterList, vendorId, date),
    // Cart lines / orders that belong to this vendor
    ofVendor: (list) => byVendor(list, rosterList, vendorId),
  };
}
